import { unitOperationsConfig } from '../../../_config/unit-operations.config';
import { WaterUnitOperation } from './water-unit-operation';
import { Case } from '../../case';
import { SimulationVariable } from '../../simulation-variable';
import { Quantity } from '../../../_config/quantity.enum';
import { UnitOperationConstraints } from '../unit-operation-constraints';
import { SimulationVariableName } from '../../../_config/simulation-variable-name.enum';
import { WaterMaterialStream } from '../../_streams/water-material-stream';
import { KpiProvider } from '../../_case-study/kpi-provider';

declare let unitConverter: any;

export class WaterSink extends WaterUnitOperation implements KpiProvider {
  category = unitOperationsConfig.waterSink.key;

  massFlowrate: SimulationVariable;
  temperature: SimulationVariable;
  pressure: SimulationVariable;
  vaporFraction: SimulationVariable;

  maximumMassFlowrate: SimulationVariable;
  minimumMassFlowrate: SimulationVariable;

  constraints: UnitOperationConstraints;

  constructor(unitOperation: any | WaterSink, ownerCase: Case) {
    super(unitOperation, ownerCase);
    this.initValues(unitOperation);
    this.setSimulationVariableNames();
  }

  override initValues(unitOperation: any) {
    super.initValues(unitOperation);
    this.massFlowrate = new SimulationVariable(unitOperation.massFlowrate, this.ownerCase, this);
    this.temperature = new SimulationVariable(unitOperation.temperature, this.ownerCase, this);
    this.pressure = new SimulationVariable(unitOperation.pressure, this.ownerCase, this);
    this.vaporFraction = new SimulationVariable(unitOperation.vaporFraction, this.ownerCase, this);

    this.maximumMassFlowrate = new SimulationVariable(unitOperation.maximumMassFlowrate, this.ownerCase, this);
    this.minimumMassFlowrate = new SimulationVariable(unitOperation.minimumMassFlowrate, this.ownerCase, this);
    this.initConstraints();
  }

  initConstraints() {
    this.constraints = new UnitOperationConstraints();
    this.constraints.addConstraint('maximumMassFlowrate', this.maximumMassFlowrate);
    this.constraints.addConstraint('minimumMassFlowrate', this.minimumMassFlowrate);
  }

  override clearResults() {
    super.clearResults();
    this.massFlowrate.value = null;
    this.temperature.value = null;
    this.pressure.value = null;
    this.vaporFraction.value = null;
  }

  override setSimulationVariableNames() {
    super.setSimulationVariableNames();
    this.massFlowrate.setName('Mass Flowrate');
    this.temperature.setName('Temperature');
    this.pressure.setName('Pressure');
    this.vaporFraction.setName('Vapor Fraction');

    this.maximumMassFlowrate.setName(SimulationVariableName.MAXIMUM_MASS_FLOWRATE);
    this.minimumMassFlowrate.setName(SimulationVariableName.MINIMUM_MASS_FLOWRATE);
  }

  override setQuantities() {
    super.setQuantities();
    this.massFlowrate.setQuantity(Quantity.MASSFLOWRATE);
    this.temperature.setQuantity(Quantity.TEMPERATURE);
    this.pressure.setQuantity(Quantity.PRESSURE);
    this.vaporFraction.setQuantity(Quantity.FRACTION);

    this.maximumMassFlowrate.setQuantity(Quantity.MASSFLOWRATE);
    this.minimumMassFlowrate.setQuantity(Quantity.MASSFLOWRATE);
  }

  override setDefaultValues() {
    super.setDefaultValues();

    if (this.massFlowrate.isUndefined()) {
      this.massFlowrate.setDefaultValue(null, unitConverter.units.Massflowrate.KPPH);
    }

    if (this.maximumMassFlowrate.isUndefined()) {
      this.maximumMassFlowrate.setDefaultValue(null, unitConverter.units.Massflowrate.KPPH);
    }

    if (this.minimumMassFlowrate.isUndefined()) {
      this.minimumMassFlowrate.setDefaultValue(null, unitConverter.units.Massflowrate.KPPH);
    }
  }

  getStreamComingInToTheUnitOp() {
    return this.ownerCase.getStreamsByOutletUnitOperationId(this.id) as WaterMaterialStream[];
  }

  getAvailableKpis(): SimulationVariable[] {
    return [
      this.getStreamComingInToTheUnitOp()[0].massFlowrate,
      this.getStreamComingInToTheUnitOp()[0].temperature,
      this.getStreamComingInToTheUnitOp()[0].pressure,
    ];
  }

  override dePersist(sup: any) {
    super.dePersist(sup);
    this.massFlowrate = this.getSimulationVariableSafe(sup.massFlowrate);
    this.temperature = this.getSimulationVariableSafe(sup.temperature);
    this.pressure = this.getSimulationVariableSafe(sup.pressure);
    this.vaporFraction = this.getSimulationVariableSafe(sup.vaporFraction);

    this.maximumMassFlowrate = this.getSimulationVariableSafe(sup.maximumMassFlowrate);
    this.minimumMassFlowrate = this.getSimulationVariableSafe(sup.minimumMassFlowrate);
    this.setQuantities();
    this.setDefaultValues();
    this.initConstraints();
  }
}
